<template>
  <div class="eleicao-conselho">
    <div class="row">
      <public-header :title="'Eleições - Conselho Tutelar'">
        <div class="col-xs-12 col-sm-6">
          <p>
            Aqui você encontra os resultados compilados das eleições do conselho
            tutelar do Município de Santos.
          </p>
          <p>
            No pleito de <span class="destaque-header">{{ ano_pleito }}</span
            >,
            <span class="destaque-header">{{ total_candidatos }}</span>
            candidatos disputaram a eleição, com um total de
            <span class="destaque-header">{{
              votos_totais.total_nominais.toLocaleString()
            }}</span>
            votos nominais,
            <span class="destaque-header">{{
              votos_totais.total_brancos.toLocaleString()
            }}</span>
            em branco e
            <span class="destaque-header">{{
              votos_totais.total_nulos.toLocaleString()
            }}</span>
            votos nulos, totalizando
            <span class="destaque-header">{{
              votos_totais.total_geral.toLocaleString()
            }}</span>
            votos válidos.
          </p>
          <p>
            Veja abaixo o ranking dos candidatos titulares e suplentes e
            selecione o candidato desejado para mais informações.
          </p>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div class="chart-wrapper">
            <BarChart
              :gradiente="false"
              :chart-data="chartData"
              :options="chartOptions"
              class="chart-size"
            />
          </div>
        </div>
      </public-header>
    </div>
    <div class="container">
      <Breadcrumb :links="[{ label: 'Eleições - Conselho Tutelar' }]" />
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <ListaCandidatos
            :title="'Titulares'"
            :lista="candidatosTitulares"
            :totalVotos="votos_totais.total_nominais"
          />
        </div>
        <div class="col-xs-12 col-md-6">
          <ListaCandidatos
            :title="'Suplentes'"
            :lista="candidatosSuplentes"
            :totalVotos="votos_totais.total_nominais"
          />
        </div>
      </div>
      <ListaCandidatosGeral
        :listaCandidatos="listaCandidatos"
        :votosNominaisTotais="votos_totais.total_nominais"
      />
      <div class="row">
        <div class="col-xs-12">
          <h3>
            Baixar Resultado
          </h3>
        </div>
        <div class="col-xs-12">
          <p>Clique abaixo para baixar a planilha com o resultado geral.</p>
          <button class="btn btn-default" @click="exportarCSVCandidatos()">
            <font-awesome-icon :icon="'file-csv'"></font-awesome-icon>
            Candidatos
          </button>
          <button class="btn btn-default" @click="exportarCSV()">
            <font-awesome-icon :icon="'file-csv'"></font-awesome-icon>
            Votos
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import {
  PublicHeader,
  BarChart,
  Breadcrumb,
  ListaCandidatos,
  ListaCandidatosGeral
} from '../../../components'
import { colors, exportCSVFile } from '../../../utils'

export default {
  components: {
    PublicHeader,
    BarChart,
    Breadcrumb,
    ListaCandidatos,
    ListaCandidatosGeral
  },
  data() {
    return {
      isLoading: true,
      ano_pleito: 2023,
      baseChart: {
        labels: ['Nominais', 'Brancos', 'Nulos'],
        datasets: [{ label: '', data: [] }]
      },
      chartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: true,
          labels: {
            fontColor: '#C1D1C1'
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMax: 50,
                fontColor: '#C1D1C1',
                callback: function(value, index, values) {
                  return value.toLocaleString()
                }
              }
            }
          ],
          xAxes: [
            {
              maxBarThickness: 50,
              ticks: {
                fontColor: '#C1D1C1'
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: function(tooltip, dataset) {
              var xLabel = dataset.datasets[tooltip.datasetIndex].label
              var yLabel = tooltip.yLabel.toLocaleString()
              return xLabel + ': ' + yLabel
            }
          }
        }
      }
    }
  },
  created() {
    this.$store.dispatch('loadCandidatos')
    this.$store.dispatch('loadVotos')
  },
  methods: {
    reducer: key => (acum, atual) => {
      return (acum += Number(atual[key]) || 0)
    },
    mountCSVHeader() {
      const headers = [
        'numero_secao',
        'data_abertura',
        'data_fechamento',
        'aptos',
        'compareceram',
        'total_nominais',
        'total_brancos',
        'total_nulos',
        'total_votos'
      ]

      const candidatos = [...this.candidatos]
        .sort((candidatoA, candidatoB) => {
          if (candidatoA.numero < candidatoB.numero) {
            return -1
          }

          if (candidatoA.numero > candidatoB.numero) {
            return 1
          }

          return 0
        })
        .map(candidato => {
          return candidato.numero
        })

      candidatos.forEach(numero => {
        headers.push(numero)
      })

      headers.push('unidade', 'endereco')

      return headers
    },
    mountCSVLines(headers) {
      const linhas = []

      this.votos.forEach(secao => {
        const voto = []

        headers.forEach(header => {
          if (header === 'total_votos') {
            voto.push(
              secao['total_nominais'] +
                secao['total_brancos'] +
                secao['total_nulos']
            )
            return
          }

          if (typeof header === 'number') {
            const { total_votos } = secao.votos.find(voto => {
              return voto.candidato.numero === header
            })

            voto.push(total_votos)
            return
          }

          if (header === 'numero_secao') {
            voto.push(secao['numero'])
          } else {
            voto.push(secao[header] || 0)
          }
        })

        linhas.push(voto)
      })

      return linhas
    },
    exportarCSV() {
      const headers = this.mountCSVHeader()
      const votos = this.mountCSVLines(headers)

      exportCSVFile(headers, votos, 'pleito')
    },
    exportarCSVCandidatos() {
      const headers = ['numero', 'nome', 'total_votos', 'posicao']
      const exportArray = []

      const candidatos = [...this.candidatos].sort((candidatoA, candidatoB) => {
        if (candidatoA.numero < candidatoB.numero) {
          return -1
        }

        if (candidatoA.numero > candidatoB.numero) {
          return 1
        }

        return 0
      })

      candidatos.forEach(candidato => {
        const line = []
        headers.forEach(header => {
          line.push(candidato[header])
        })
        exportArray.push(line)
      })

      exportCSVFile(headers, exportArray, 'candidatos')
    }
  },
  computed: {
    ...mapState({
      votos: ({ eleicoes_conselho }) => eleicoes_conselho.votos,
      candidatos: ({ eleicoes_conselho }) => eleicoes_conselho.candidatos
    }),
    ...mapGetters({
      votos_totais: 'votosTotais'
    }),
    listaCandidatos() {
      return this.candidatos
    },
    total_candidatos() {
      return this.candidatos.length
    },
    candidatosTitulares() {
      return this.candidatos.slice(0, 15)
    },
    candidatosSuplentes() {
      return this.candidatos.slice(15, 30)
    },
    chartData() {
      const datasets = [
        {
          label: this.ano_pleito,
          data: [
            this.votos_totais.total_nominais,
            this.votos_totais.total_brancos,
            this.votos_totais.total_nulos
          ],
          backgroundColor: colors.coresHexa[0]
        }
      ]

      return {
        ...this.baseChart,
        datasets
      }
    }
  }
}
</script>

<style scoped>
.chart-wrapper {
  height: 300px;
}

.chart-size {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/public/eleicao_conselho/index.vue